import { AxiosError } from 'axios';
import { InfiniteData, QueryKey, useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';

export const useAxiosQuery = <T>(
  ...[options, client]: Parameters<typeof useQuery<T, AxiosError<{ message: string }>>>
) => {
  const { isFetching, error, data } = useQuery<T, AxiosError<{ message: string }>>(options, client);
  return { loading: isFetching, error, data } as const;
};

export const useAxiosMutation = <T, V = void>(
  ...[options, client]: Parameters<typeof useMutation<T, AxiosError<{ message: string }>, V>>
) => {
  const { mutateAsync, isPending, error, data } = useMutation<T, AxiosError<{ message: string }>, V>(
    options,
    client,
  );
  return [mutateAsync, { loading: isPending, error, data }] as const;
};

export const useAxiosInfiniteQuery = <T>(
  ...[options, client]: Parameters<
    typeof useInfiniteQuery<T, AxiosError<{ message: string }>, InfiniteData<T>, QueryKey, number | undefined>
  >
) => {
  const { isFetching, error, data, fetchNextPage, hasNextPage } = useInfiniteQuery<
    T,
    AxiosError<{ message: string }>,
    InfiniteData<T>,
    QueryKey,
    number | undefined
  >(options, client);
  return { loading: isFetching, error, data, fetchNextPage, hasNextPage } as const;
};;
